import React from "react";
import Navbar from "./Navbar";

const Page = ({ children, style, className }: { 
  children: React.ReactNode; 
  style?: React.CSSProperties;
  className?: string;
}) => {
  return (
    <div className={`page ${className || ''}`} style={style}>
      <Navbar />
      {children}
    </div>
  );
};

export default Page;
